import React from 'react';
import "./WorkExperience.css"
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {MdGroupWork } from "react-icons/md";




const WorkExperience = () => {
    const data=[
{
        companyname:"Huming Bytes",
        poston:"(Fullstack Developer)",
        des:"Developed 10+ full-stack web applications to analyze and process data for different clients. Work closely with app development team including project and product manager developers, and QA to determine problems, testing methods, and best practices. Optimized company's complaint handling process by creating and delivering highly efficient app-based solutions",
        year:"2022",
        techskills:[
            {
                techname:"React js",
            },
            {
                techname:"Node js",
            },
            {
                techname:"Javascript",
            },
            {
                techname:"JQuery",
            }
        ]
},
{
    companyname:"Korus Computer Classes",
    poston:"(Educator)",
    des:"Computer teacher with 1+ years experience teaching courses in C, C++, Python, Java and Web-Development, with a specialization in teaching advanced streams. Contributed to a 20% increase in Programing Subjectts scores in above languages. Prepared bespoke lesson plans for students identified as requiring specialized teaching.",
    year:"2022",
    techskills:[
        {
            techname:"C",
        },
        {
            techname:"C++",
        },
        {
            techname:"Java",
        },
        {
            techname:"Python",
        },
        {
            techname:"HTML/CSS",
        },
        {
            techname:"PHP",
        }
    ]
},
{
    companyname:"Virgo BPO-Services",
    poston:"(Catalogue Work)",
    des:"Entering customer and account data from source documents within time limits. Compiling, verifying accuracy and sorting information to prepare source data for computer entry. Reviewing data for deficiencies or errors, correcting any incompatibilities and checking output",
    year:"2021-2022",
    techskills:[
        {
            techname:"Cataloguer",
        },
        {
            techname:"Data-Entry",
        },
       
    ]
},
{
    companyname:"Super Collapsible Tubes Ltd.",
    poston:"(Quality Checker)",
    des:"Execute quality assurance measures on all finished goods and incoming raw materials.Examine the plans, specifications, and blueprints carefully to understand the product requirements.Reject all arriving raw materials that do not comply with quality expectations and report the issue to the appropriate subdivision as soon as possible.",
    year:"2020-2021",
    techskills:[
        {
            techname:"Quality-Analyst",
        },
        {
            techname:"Store-Assistant",
        },
       
    ]
}

    ];

    const colors=[
        "#FFBB28",
        "#4B088A",
        "#FF8042",
        "#001CCE"
    ]

    return (
<div className="container workexperience-section" id="workexperience">
<div className='section-title'>
        <h5>Work experience</h5>
        <span className="line"></span>
       </div>
<div className="timeline-section">
       <VerticalTimeline lineColor='#FF1042'>

{data.map((item,index)=>(
     <VerticalTimelineElement
     className="vertical-timeline-element--work"
     contentStyle={{ background: colors[index], color: '#fff' }}
     contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
     date={item.year}
     dateClassName="date-class"
     iconStyle={{ background: colors[index], color: '#fff' }}
     icon={<MdGroupWork />}
   >
     <h3 className="vertical-timeline-element-title">{item.companyname}</h3>
     <h4 className="vertical-timeline-element-subtitle">{item.poston}</h4>

     <div className="row">
          {item.techskills.map((tec,index)=>(
 <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12" key={index} >

            <div className="tech-skills">
                <p>{tec.techname}</p>
</div>
 </div>
          ))}
           
             </div>

     <p>{item.des}</p>
   </VerticalTimelineElement>
))}
</VerticalTimeline>
</div>

</div>
        );
    };
    export default WorkExperience;